export default __webpack_public_path__ + "static/media/learose2-768w.881bd09f.avif";